var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ManagementRole",
      staticStyle: {
        padding: "30px",
        background: "#FFFFFF",
        "border-radius": "10px"
      }
    },
    [
      _c("h4", [_vm._v(_vm._s(_vm.$t("i18n_role_management")))]),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticStyle: { margin: "20px" },
          attrs: { type: "primary" },
          on: {
            click: function($event) {
              return _vm.addRole()
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("i18n_create_new_role")))]
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "97%", "margin-left": "17px" },
          attrs: {
            border: "",
            data: _vm.tableData,
            "max-height": "500px",
            "tooltip-effect": "dark",
            "header-cell-style": { background: "#F3F3F3" }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: _vm.$t("i18n_Serial_number"),
              width: "60px",
              "min-width": "8%"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "cnName",
              label: _vm.$t("i18n_role_name_in_chinese"),
              "min-width": "10%"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "enName",
              label: _vm.$t("i18n_role_name_in_English"),
              "min-width": "10%"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "statuss",
              label: _vm.$t("i18n_Roles"),
              "min-width": "10%"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "remark",
              label: _vm.$t("i18n_remark"),
              "min-width": "10%"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: _vm.$t("i18n_creation_time"),
              "min-width": "10%"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "operation",
              label: _vm.$t("i18n_Operation"),
              "min-width": "10%"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.amend(scope)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.gobalbuyer(scope)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_View_permissions")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.PermisAssign(scope)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_Permission_assignment")))]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.panelBox,
              expression: "panelBox"
            }
          ],
          staticClass: "panelBox"
        },
        [
          _c(
            "div",
            { staticClass: "panel" },
            [
              _c("i", {
                staticClass: "el-icon-circle-close close",
                on: {
                  click: function($event) {
                    return _vm.closePanel()
                  }
                }
              }),
              _vm._v(" "),
              _vm.addPanel
                ? _c("h4", [_vm._v(_vm._s(_vm.$t("i18n_create_new_role")))])
                : _c("h4", [_vm._v(_vm._s(_vm.$t("i18n_Modify_Role")))]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "roleForm",
                  attrs: {
                    "label-position": _vm.labelPosition,
                    rules: _vm.rules,
                    model: _vm.roleForm,
                    "label-width": "80px",
                    size: "mini",
                    "hide-required-asterisk": ""
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("i18n_role_name_in_chinese"),
                        prop: "cnName"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: _vm.$t("i18n_please_enter") },
                        model: {
                          value: _vm.roleForm.cnName,
                          callback: function($$v) {
                            _vm.$set(_vm.roleForm, "cnName", $$v)
                          },
                          expression: "roleForm.cnName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("i18n_role_name_in_English"),
                        prop: "enName"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: _vm.$t("i18n_please_enter") },
                        model: {
                          value: _vm.roleForm.enName,
                          callback: function($$v) {
                            _vm.$set(_vm.roleForm, "enName", $$v)
                          },
                          expression: "roleForm.enName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("i18n_Status"), prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.addPls("i18n_Status", "select")
                          },
                          model: {
                            value: _vm.roleForm.status,
                            callback: function($$v) {
                              _vm.$set(_vm.roleForm, "status", $$v)
                            },
                            expression: "roleForm.status"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: _vm.$t("i18n_Enable"), value: "1" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: _vm.$t("i18n_Disable"), value: "0" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "min-height": "80px" },
                      attrs: { label: _vm.$t("i18n_remark"), prop: "remark" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { "min-height": "80px" },
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.roleForm.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.roleForm, "remark", $$v)
                          },
                          expression: "roleForm.remark"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.addPanel
                    ? _c(
                        "el-row",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.goonadd("roleForm")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("i18n_Confirm_continue")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.addRoleend("roleForm")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("i18n_Confirm")))]
                          )
                        ],
                        1
                      )
                    : _c(
                        "el-row",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.amendend("roleForm")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("i18n_confirm_edit")))]
                          )
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c21d450", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c21d450","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/accountManage/ManagementRole.vue
// module id = null
// module chunks = 